// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer--3QL6W","text":"text--mdphH"};


//////////////////
// WEBPACK FOOTER
// ./src/Footer/Footer.css
// module id = VwrH
// module chunks = 1